import { Combobox } from 'medere-ui-framework'
import { ColumnFilterElementTemplateOptions } from 'primereact/column'
import {
  CONTRACT_HONORARIUM_STATUS_CODES,
  ContractHonorariumStatus,
} from '../../../dto/contractHonorarium/ContractHonorariumDTO'
import { STATUS_LABELS } from '../contractHonorariumFormat'

interface StatusOption {
  id: number
  name: string
}

const STATUSES: ContractHonorariumStatus[] = ['CURRENT', 'FUTURE', 'EXPIRED']
const STATUS_OPTIONS: StatusOption[] = STATUSES.map((status) => ({
  id: CONTRACT_HONORARIUM_STATUS_CODES[status],
  name: STATUS_LABELS[status],
}))

function isStatusOption(value: unknown): value is StatusOption {
  return typeof value === 'object' && value !== null && typeof (value as { id?: unknown }).id === 'number'
}

interface Props {
  filterOptions: ColumnFilterElementTemplateOptions
}

export default function StatusFilter({ filterOptions }: Props) {
  const selected = STATUS_OPTIONS.find((option) => option.id === filterOptions.value) ?? null

  return (
    <Combobox
      list={STATUS_OPTIONS}
      value={selected}
      setValue={(value: unknown) => filterOptions.filterApplyCallback(isStatusOption(value) ? value.id : null)}
      optionLabel='name'
      placeholder='Todos'
      className='w-full'
    />
  )
}
